export default __webpack_public_path__ + "static/media/Dead Iron Hammer.64d4ae41.jpg";